"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoTIFFImage = exports.Pool = exports.writeArrayBuffer = exports.fromUrls = exports.fromBlob = exports.fromFile = exports.fromArrayBuffer = exports.fromUrl = exports.MultiGeoTIFF = exports.GeoTIFF = exports.setLogger = exports.addDecoder = exports.getDecoder = exports.BaseDecoder = exports.rgb = exports.globals = void 0;
/** @module geotiff */

var geotiffimage_js_1 = __importDefault(require("./geotiffimage.js"));

exports.GeoTIFFImage = geotiffimage_js_1.default;

var dataview64_js_1 = __importDefault(require("./dataview64.js"));

var dataslice_js_1 = __importDefault(require("./dataslice.js"));

var pool_js_1 = __importDefault(require("./pool.js"));

exports.Pool = pool_js_1.default;

var remote_js_1 = require("./source/remote.js");

var arraybuffer_js_1 = require("./source/arraybuffer.js");

var filereader_js_1 = require("./source/filereader.js");

var file_js_1 = require("./source/file.js");

var globals_js_1 = require("./globals.js");

var geotiffwriter_js_1 = require("./geotiffwriter.js");

var globals = __importStar(require("./globals.js"));

exports.globals = globals;

var rgb = __importStar(require("./rgb.js"));

exports.rgb = rgb;

var index_js_1 = require("./compression/index.js");

Object.defineProperty(exports, "getDecoder", {
  enumerable: true,
  get: function get() {
    return index_js_1.getDecoder;
  }
});
Object.defineProperty(exports, "addDecoder", {
  enumerable: true,
  get: function get() {
    return index_js_1.addDecoder;
  }
});

var logging_js_1 = require("./logging.js");

Object.defineProperty(exports, "setLogger", {
  enumerable: true,
  get: function get() {
    return logging_js_1.setLogger;
  }
});

var basedecoder_js_1 = require("./compression/basedecoder.js");

Object.defineProperty(exports, "BaseDecoder", {
  enumerable: true,
  get: function get() {
    return __importDefault(basedecoder_js_1).default;
  }
});
/**
 * @typedef {Uint8Array | Int8Array | Uint16Array | Int16Array | Uint32Array | Int32Array | Float32Array | Float64Array}
 * TypedArray
 */

/**
 * @typedef {{ height:number, width: number }} Dimensions
 */

/**
 * The autogenerated docs are a little confusing here. The effective type is:
 *
 * `TypedArray & { height: number; width: number}`
 * @typedef {TypedArray & Dimensions} TypedArrayWithDimensions
 */

/**
 * The autogenerated docs are a little confusing here. The effective type is:
 *
 * `TypedArray[] & { height: number; width: number}`
 * @typedef {TypedArray[] & Dimensions} TypedArrayArrayWithDimensions
 */

/**
 *  The autogenerated docs are a little confusing here. The effective type is:
 *
 * `(TypedArray | TypedArray[]) & { height: number; width: number}`
 * @typedef {TypedArrayWithDimensions | TypedArrayArrayWithDimensions} ReadRasterResult
 */

function getFieldTypeLength(fieldType) {
  switch (fieldType) {
    case globals_js_1.fieldTypes.BYTE:
    case globals_js_1.fieldTypes.ASCII:
    case globals_js_1.fieldTypes.SBYTE:
    case globals_js_1.fieldTypes.UNDEFINED:
      return 1;

    case globals_js_1.fieldTypes.SHORT:
    case globals_js_1.fieldTypes.SSHORT:
      return 2;

    case globals_js_1.fieldTypes.LONG:
    case globals_js_1.fieldTypes.SLONG:
    case globals_js_1.fieldTypes.FLOAT:
    case globals_js_1.fieldTypes.IFD:
      return 4;

    case globals_js_1.fieldTypes.RATIONAL:
    case globals_js_1.fieldTypes.SRATIONAL:
    case globals_js_1.fieldTypes.DOUBLE:
    case globals_js_1.fieldTypes.LONG8:
    case globals_js_1.fieldTypes.SLONG8:
    case globals_js_1.fieldTypes.IFD8:
      return 8;

    default:
      throw new RangeError("Invalid field type: ".concat(fieldType));
  }
}

function parseGeoKeyDirectory(fileDirectory) {
  var rawGeoKeyDirectory = fileDirectory.GeoKeyDirectory;

  if (!rawGeoKeyDirectory) {
    return null;
  }

  var geoKeyDirectory = {};

  for (var i = 4; i <= rawGeoKeyDirectory[3] * 4; i += 4) {
    var key = globals_js_1.geoKeyNames[rawGeoKeyDirectory[i]];
    var location = rawGeoKeyDirectory[i + 1] ? globals_js_1.fieldTagNames[rawGeoKeyDirectory[i + 1]] : null;
    var count = rawGeoKeyDirectory[i + 2];
    var offset = rawGeoKeyDirectory[i + 3];
    var value = null;

    if (!location) {
      value = offset;
    } else {
      value = fileDirectory[location];

      if (typeof value === 'undefined' || value === null) {
        throw new Error("Could not get value of geoKey '".concat(key, "'."));
      } else if (typeof value === 'string') {
        value = value.substring(offset, offset + count - 1);
      } else if (value.subarray) {
        value = value.subarray(offset, offset + count);

        if (count === 1) {
          value = value[0];
        }
      }
    }

    geoKeyDirectory[key] = value;
  }

  return geoKeyDirectory;
}

function getValues(dataSlice, fieldType, count, offset) {
  var values = null;
  var readMethod = null;
  var fieldTypeLength = getFieldTypeLength(fieldType);

  switch (fieldType) {
    case globals_js_1.fieldTypes.BYTE:
    case globals_js_1.fieldTypes.ASCII:
    case globals_js_1.fieldTypes.UNDEFINED:
      values = new Uint8Array(count);
      readMethod = dataSlice.readUint8;
      break;

    case globals_js_1.fieldTypes.SBYTE:
      values = new Int8Array(count);
      readMethod = dataSlice.readInt8;
      break;

    case globals_js_1.fieldTypes.SHORT:
      values = new Uint16Array(count);
      readMethod = dataSlice.readUint16;
      break;

    case globals_js_1.fieldTypes.SSHORT:
      values = new Int16Array(count);
      readMethod = dataSlice.readInt16;
      break;

    case globals_js_1.fieldTypes.LONG:
    case globals_js_1.fieldTypes.IFD:
      values = new Uint32Array(count);
      readMethod = dataSlice.readUint32;
      break;

    case globals_js_1.fieldTypes.SLONG:
      values = new Int32Array(count);
      readMethod = dataSlice.readInt32;
      break;

    case globals_js_1.fieldTypes.LONG8:
    case globals_js_1.fieldTypes.IFD8:
      values = new Array(count);
      readMethod = dataSlice.readUint64;
      break;

    case globals_js_1.fieldTypes.SLONG8:
      values = new Array(count);
      readMethod = dataSlice.readInt64;
      break;

    case globals_js_1.fieldTypes.RATIONAL:
      values = new Uint32Array(count * 2);
      readMethod = dataSlice.readUint32;
      break;

    case globals_js_1.fieldTypes.SRATIONAL:
      values = new Int32Array(count * 2);
      readMethod = dataSlice.readInt32;
      break;

    case globals_js_1.fieldTypes.FLOAT:
      values = new Float32Array(count);
      readMethod = dataSlice.readFloat32;
      break;

    case globals_js_1.fieldTypes.DOUBLE:
      values = new Float64Array(count);
      readMethod = dataSlice.readFloat64;
      break;

    default:
      throw new RangeError("Invalid field type: ".concat(fieldType));
  } // normal fields


  if (!(fieldType === globals_js_1.fieldTypes.RATIONAL || fieldType === globals_js_1.fieldTypes.SRATIONAL)) {
    for (var i = 0; i < count; ++i) {
      values[i] = readMethod.call(dataSlice, offset + i * fieldTypeLength);
    }
  } else {
    // RATIONAL or SRATIONAL
    for (var _i = 0; _i < count; _i += 2) {
      values[_i] = readMethod.call(dataSlice, offset + _i * fieldTypeLength);
      values[_i + 1] = readMethod.call(dataSlice, offset + (_i * fieldTypeLength + 4));
    }
  }

  if (fieldType === globals_js_1.fieldTypes.ASCII) {
    return new TextDecoder('utf-8').decode(values);
  }

  return values;
}
/**
 * Data class to store the parsed file directory, geo key directory and
 * offset to the next IFD
 */


var ImageFileDirectory = /*#__PURE__*/(0, _createClass2.default)(function ImageFileDirectory(fileDirectory, geoKeyDirectory, nextIFDByteOffset) {
  (0, _classCallCheck2.default)(this, ImageFileDirectory);
  this.fileDirectory = fileDirectory;
  this.geoKeyDirectory = geoKeyDirectory;
  this.nextIFDByteOffset = nextIFDByteOffset;
});
/**
 * Error class for cases when an IFD index was requested, that does not exist
 * in the file.
 */

var GeoTIFFImageIndexError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(GeoTIFFImageIndexError, _Error);

  var _super = _createSuper(GeoTIFFImageIndexError);

  function GeoTIFFImageIndexError(index) {
    var _this;

    (0, _classCallCheck2.default)(this, GeoTIFFImageIndexError);
    _this = _super.call(this, "No image at index ".concat(index));
    _this.index = index;
    return _this;
  }

  return (0, _createClass2.default)(GeoTIFFImageIndexError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

var GeoTIFFBase = /*#__PURE__*/function () {
  function GeoTIFFBase() {
    (0, _classCallCheck2.default)(this, GeoTIFFBase);
  }

  (0, _createClass2.default)(GeoTIFFBase, [{
    key: "readRasters",
    value:
    /**
     * (experimental) Reads raster data from the best fitting image. This function uses
     * the image with the lowest resolution that is still a higher resolution than the
     * requested resolution.
     * When specified, the `bbox` option is translated to the `window` option and the
     * `resX` and `resY` to `width` and `height` respectively.
     * Then, the [readRasters]{@link GeoTIFFImage#readRasters} method of the selected
     * image is called and the result returned.
     * @see GeoTIFFImage.readRasters
     * @param {import('./geotiffimage').ReadRasterOptions} [options={}] optional parameters
     * @returns {Promise<ReadRasterResult>} the decoded array(s), with `height` and `width`, as a promise
     */
    function () {
      var _readRasters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var options,
            imageWindow,
            width,
            height,
            resX,
            resY,
            bbox,
            firstImage,
            usedImage,
            imageCount,
            imgBBox,
            _firstImage$getOrigin,
            _firstImage$getOrigin2,
            oX,
            oY,
            _firstImage$getResolu,
            _firstImage$getResolu2,
            rX,
            rY,
            usedBBox,
            allImages,
            i,
            image,
            _image$fileDirectory,
            subfileType,
            newSubfileType,
            _i2,
            _image,
            imgResX,
            imgResY,
            wnd,
            _firstImage$getOrigin3,
            _firstImage$getOrigin4,
            _oX,
            _oY,
            _usedImage$getResolut,
            _usedImage$getResolut2,
            imageResX,
            imageResY,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                imageWindow = options.window, width = options.width, height = options.height;
                resX = options.resX, resY = options.resY, bbox = options.bbox;
                _context.next = 5;
                return this.getImage();

              case 5:
                firstImage = _context.sent;
                usedImage = firstImage;
                _context.next = 9;
                return this.getImageCount();

              case 9:
                imageCount = _context.sent;
                imgBBox = firstImage.getBoundingBox();

                if (!(imageWindow && bbox)) {
                  _context.next = 13;
                  break;
                }

                throw new Error('Both "bbox" and "window" passed.');

              case 13:
                if (!(width || height)) {
                  _context.next = 24;
                  break;
                }

                // if we have an image window (pixel coordinates), transform it to a BBox
                // using the origin/resolution of the first image.
                if (imageWindow) {
                  _firstImage$getOrigin = firstImage.getOrigin(), _firstImage$getOrigin2 = (0, _slicedToArray2.default)(_firstImage$getOrigin, 2), oX = _firstImage$getOrigin2[0], oY = _firstImage$getOrigin2[1];
                  _firstImage$getResolu = firstImage.getResolution(), _firstImage$getResolu2 = (0, _slicedToArray2.default)(_firstImage$getResolu, 2), rX = _firstImage$getResolu2[0], rY = _firstImage$getResolu2[1];
                  bbox = [oX + imageWindow[0] * rX, oY + imageWindow[1] * rY, oX + imageWindow[2] * rX, oY + imageWindow[3] * rY];
                } // if we have a bbox (or calculated one)


                usedBBox = bbox || imgBBox;

                if (!width) {
                  _context.next = 20;
                  break;
                }

                if (!resX) {
                  _context.next = 19;
                  break;
                }

                throw new Error('Both width and resX passed');

              case 19:
                resX = (usedBBox[2] - usedBBox[0]) / width;

              case 20:
                if (!height) {
                  _context.next = 24;
                  break;
                }

                if (!resY) {
                  _context.next = 23;
                  break;
                }

                throw new Error('Both width and resY passed');

              case 23:
                resY = (usedBBox[3] - usedBBox[1]) / height;

              case 24:
                if (!(resX || resY)) {
                  _context.next = 48;
                  break;
                }

                allImages = [];
                i = 0;

              case 27:
                if (!(i < imageCount)) {
                  _context.next = 36;
                  break;
                }

                _context.next = 30;
                return this.getImage(i);

              case 30:
                image = _context.sent;
                _image$fileDirectory = image.fileDirectory, subfileType = _image$fileDirectory.SubfileType, newSubfileType = _image$fileDirectory.NewSubfileType;

                if (i === 0 || subfileType === 2 || newSubfileType & 1) {
                  allImages.push(image);
                }

              case 33:
                ++i;
                _context.next = 27;
                break;

              case 36:
                allImages.sort(function (a, b) {
                  return a.getWidth() - b.getWidth();
                });
                _i2 = 0;

              case 38:
                if (!(_i2 < allImages.length)) {
                  _context.next = 48;
                  break;
                }

                _image = allImages[_i2];
                imgResX = (imgBBox[2] - imgBBox[0]) / _image.getWidth();
                imgResY = (imgBBox[3] - imgBBox[1]) / _image.getHeight();
                usedImage = _image;

                if (!(resX && resX > imgResX || resY && resY > imgResY)) {
                  _context.next = 45;
                  break;
                }

                return _context.abrupt("break", 48);

              case 45:
                ++_i2;
                _context.next = 38;
                break;

              case 48:
                wnd = imageWindow;

                if (bbox) {
                  _firstImage$getOrigin3 = firstImage.getOrigin(), _firstImage$getOrigin4 = (0, _slicedToArray2.default)(_firstImage$getOrigin3, 2), _oX = _firstImage$getOrigin4[0], _oY = _firstImage$getOrigin4[1];
                  _usedImage$getResolut = usedImage.getResolution(firstImage), _usedImage$getResolut2 = (0, _slicedToArray2.default)(_usedImage$getResolut, 2), imageResX = _usedImage$getResolut2[0], imageResY = _usedImage$getResolut2[1];
                  wnd = [Math.round((bbox[0] - _oX) / imageResX), Math.round((bbox[1] - _oY) / imageResY), Math.round((bbox[2] - _oX) / imageResX), Math.round((bbox[3] - _oY) / imageResY)];
                  wnd = [Math.min(wnd[0], wnd[2]), Math.min(wnd[1], wnd[3]), Math.max(wnd[0], wnd[2]), Math.max(wnd[1], wnd[3])];
                }

                return _context.abrupt("return", usedImage.readRasters(_objectSpread(_objectSpread({}, options), {}, {
                  window: wnd
                })));

              case 51:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readRasters() {
        return _readRasters.apply(this, arguments);
      }

      return readRasters;
    }()
  }]);
  return GeoTIFFBase;
}();
/**
 * @typedef {Object} GeoTIFFOptions
 * @property {boolean} [cache=false] whether or not decoded tiles shall be cached.
 */

/**
 * The abstraction for a whole GeoTIFF file.
 * @augments GeoTIFFBase
 */


var GeoTIFF = /*#__PURE__*/function (_GeoTIFFBase) {
  (0, _inherits2.default)(GeoTIFF, _GeoTIFFBase);

  var _super2 = _createSuper(GeoTIFF);

  /**
   * @constructor
   * @param {*} source The datasource to read from.
   * @param {boolean} littleEndian Whether the image uses little endian.
   * @param {boolean} bigTiff Whether the image uses bigTIFF conventions.
   * @param {number} firstIFDOffset The numeric byte-offset from the start of the image
   *                                to the first IFD.
   * @param {GeoTIFFOptions} [options] further options.
   */
  function GeoTIFF(source, littleEndian, bigTiff, firstIFDOffset) {
    var _this2;

    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    (0, _classCallCheck2.default)(this, GeoTIFF);
    _this2 = _super2.call(this);
    _this2.source = source;
    _this2.littleEndian = littleEndian;
    _this2.bigTiff = bigTiff;
    _this2.firstIFDOffset = firstIFDOffset;
    _this2.cache = options.cache || false;
    _this2.ifdRequests = [];
    _this2.ghostValues = null;
    return _this2;
  }

  (0, _createClass2.default)(GeoTIFF, [{
    key: "getSlice",
    value: function () {
      var _getSlice = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(offset, size) {
        var fallbackSize;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fallbackSize = this.bigTiff ? 4048 : 1024;
                _context2.t0 = dataslice_js_1.default;
                _context2.next = 4;
                return this.source.fetch([{
                  offset: offset,
                  length: typeof size !== 'undefined' ? size : fallbackSize
                }]);

              case 4:
                _context2.t1 = _context2.sent[0];
                _context2.t2 = offset;
                _context2.t3 = this.littleEndian;
                _context2.t4 = this.bigTiff;
                return _context2.abrupt("return", new _context2.t0(_context2.t1, _context2.t2, _context2.t3, _context2.t4));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSlice(_x, _x2) {
        return _getSlice.apply(this, arguments);
      }

      return getSlice;
    }()
    /**
     * Instructs to parse an image file directory at the given file offset.
     * As there is no way to ensure that a location is indeed the start of an IFD,
     * this function must be called with caution (e.g only using the IFD offsets from
     * the headers or other IFDs).
     * @param {number} offset the offset to parse the IFD at
     * @returns {Promise<ImageFileDirectory>} the parsed IFD
     */

  }, {
    key: "parseFileDirectoryAt",
    value: function () {
      var _parseFileDirectoryAt = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(offset) {
        var entrySize, offsetSize, dataSlice, numDirEntries, byteSize, fileDirectory, i, entryCount, fieldTag, fieldType, typeCount, fieldValues, value, fieldTypeLength, valueOffset, actualOffset, length, fieldDataSlice, geoKeyDirectory, nextIFDByteOffset;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                entrySize = this.bigTiff ? 20 : 12;
                offsetSize = this.bigTiff ? 8 : 2;
                _context3.next = 4;
                return this.getSlice(offset);

              case 4:
                dataSlice = _context3.sent;
                numDirEntries = this.bigTiff ? dataSlice.readUint64(offset) : dataSlice.readUint16(offset); // if the slice does not cover the whole IFD, request a bigger slice, where the
                // whole IFD fits: num of entries + n x tag length + offset to next IFD

                byteSize = numDirEntries * entrySize + (this.bigTiff ? 16 : 6);

                if (dataSlice.covers(offset, byteSize)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 10;
                return this.getSlice(offset, byteSize);

              case 10:
                dataSlice = _context3.sent;

              case 11:
                fileDirectory = {}; // loop over the IFD and create a file directory object

                i = offset + (this.bigTiff ? 8 : 2);
                entryCount = 0;

              case 14:
                if (!(entryCount < numDirEntries)) {
                  _context3.next = 41;
                  break;
                }

                fieldTag = dataSlice.readUint16(i);
                fieldType = dataSlice.readUint16(i + 2);
                typeCount = this.bigTiff ? dataSlice.readUint64(i + 4) : dataSlice.readUint32(i + 4);
                fieldValues = void 0;
                value = void 0;
                fieldTypeLength = getFieldTypeLength(fieldType);
                valueOffset = i + (this.bigTiff ? 12 : 8); // check whether the value is directly encoded in the tag or refers to a
                // different external byte range

                if (!(fieldTypeLength * typeCount <= (this.bigTiff ? 8 : 4))) {
                  _context3.next = 26;
                  break;
                }

                fieldValues = getValues(dataSlice, fieldType, typeCount, valueOffset);
                _context3.next = 36;
                break;

              case 26:
                // resolve the reference to the actual byte range
                actualOffset = dataSlice.readOffset(valueOffset);
                length = getFieldTypeLength(fieldType) * typeCount; // check, whether we actually cover the referenced byte range; if not,
                // request a new slice of bytes to read from it

                if (!dataSlice.covers(actualOffset, length)) {
                  _context3.next = 32;
                  break;
                }

                fieldValues = getValues(dataSlice, fieldType, typeCount, actualOffset);
                _context3.next = 36;
                break;

              case 32:
                _context3.next = 34;
                return this.getSlice(actualOffset, length);

              case 34:
                fieldDataSlice = _context3.sent;
                fieldValues = getValues(fieldDataSlice, fieldType, typeCount, actualOffset);

              case 36:
                // unpack single values from the array
                if (typeCount === 1 && globals_js_1.arrayFields.indexOf(fieldTag) === -1 && !(fieldType === globals_js_1.fieldTypes.RATIONAL || fieldType === globals_js_1.fieldTypes.SRATIONAL)) {
                  value = fieldValues[0];
                } else {
                  value = fieldValues;
                } // write the tags value to the file directly


                fileDirectory[globals_js_1.fieldTagNames[fieldTag]] = value;

              case 38:
                i += entrySize, ++entryCount;
                _context3.next = 14;
                break;

              case 41:
                geoKeyDirectory = parseGeoKeyDirectory(fileDirectory);
                nextIFDByteOffset = dataSlice.readOffset(offset + offsetSize + entrySize * numDirEntries);
                return _context3.abrupt("return", new ImageFileDirectory(fileDirectory, geoKeyDirectory, nextIFDByteOffset));

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function parseFileDirectoryAt(_x3) {
        return _parseFileDirectoryAt.apply(this, arguments);
      }

      return parseFileDirectoryAt;
    }()
  }, {
    key: "requestIFD",
    value: function () {
      var _requestIFD = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(index) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.ifdRequests[index]) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", this.ifdRequests[index]);

              case 4:
                if (!(index === 0)) {
                  _context5.next = 9;
                  break;
                }

                // special case for index 0
                this.ifdRequests[index] = this.parseFileDirectoryAt(this.firstIFDOffset);
                return _context5.abrupt("return", this.ifdRequests[index]);

              case 9:
                if (this.ifdRequests[index - 1]) {
                  _context5.next = 19;
                  break;
                }

                _context5.prev = 10;
                this.ifdRequests[index - 1] = this.requestIFD(index - 1);
                _context5.next = 19;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](10);

                if (!(_context5.t0 instanceof GeoTIFFImageIndexError)) {
                  _context5.next = 18;
                  break;
                }

                throw new GeoTIFFImageIndexError(index);

              case 18:
                throw _context5.t0;

              case 19:
                // if the previous IFD was loaded, we can finally fetch the one we are interested in.
                // we need to wrap this in an IIFE, otherwise this.ifdRequests[index] would be delayed
                this.ifdRequests[index] = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
                  var previousIfd;
                  return _regenerator.default.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this3.ifdRequests[index - 1];

                        case 2:
                          previousIfd = _context4.sent;

                          if (!(previousIfd.nextIFDByteOffset === 0)) {
                            _context4.next = 5;
                            break;
                          }

                          throw new GeoTIFFImageIndexError(index);

                        case 5:
                          return _context4.abrupt("return", _this3.parseFileDirectoryAt(previousIfd.nextIFDByteOffset));

                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }))();
                return _context5.abrupt("return", this.ifdRequests[index]);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[10, 14]]);
      }));

      function requestIFD(_x4) {
        return _requestIFD.apply(this, arguments);
      }

      return requestIFD;
    }()
    /**
     * Get the n-th internal subfile of an image. By default, the first is returned.
     *
     * @param {number} [index=0] the index of the image to return.
     * @returns {Promise<GeoTIFFImage>} the image at the given index
     */

  }, {
    key: "getImage",
    value: function () {
      var _getImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var index,
            ifd,
            _args6 = arguments;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                index = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : 0;
                _context6.next = 3;
                return this.requestIFD(index);

              case 3:
                ifd = _context6.sent;
                return _context6.abrupt("return", new geotiffimage_js_1.default(ifd.fileDirectory, ifd.geoKeyDirectory, this.dataView, this.littleEndian, this.cache, this.source));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getImage() {
        return _getImage.apply(this, arguments);
      }

      return getImage;
    }()
    /**
     * Returns the count of the internal subfiles.
     *
     * @returns {Promise<number>} the number of internal subfile images
     */

  }, {
    key: "getImageCount",
    value: function () {
      var _getImageCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var index, hasNext;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                index = 0; // loop until we run out of IFDs

                hasNext = true;

              case 2:
                if (!hasNext) {
                  _context7.next = 18;
                  break;
                }

                _context7.prev = 3;
                _context7.next = 6;
                return this.requestIFD(index);

              case 6:
                ++index;
                _context7.next = 16;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](3);

                if (!(_context7.t0 instanceof GeoTIFFImageIndexError)) {
                  _context7.next = 15;
                  break;
                }

                hasNext = false;
                _context7.next = 16;
                break;

              case 15:
                throw _context7.t0;

              case 16:
                _context7.next = 2;
                break;

              case 18:
                return _context7.abrupt("return", index);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 9]]);
      }));

      function getImageCount() {
        return _getImageCount.apply(this, arguments);
      }

      return getImageCount;
    }()
    /**
     * Get the values of the COG ghost area as a parsed map.
     * See https://gdal.org/drivers/raster/cog.html#header-ghost-area for reference
     * @returns {Promise<Object>} the parsed ghost area or null, if no such area was found
     */

  }, {
    key: "getGhostValues",
    value: function () {
      var _getGhostValues = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var _this4 = this;

        var offset, detectionString, heuristicAreaSize, slice, valuesString, firstLine, metadataSize, fullString;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                offset = this.bigTiff ? 16 : 8;

                if (!this.ghostValues) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return", this.ghostValues);

              case 3:
                detectionString = 'GDAL_STRUCTURAL_METADATA_SIZE=';
                heuristicAreaSize = detectionString.length + 100;
                _context8.next = 7;
                return this.getSlice(offset, heuristicAreaSize);

              case 7:
                slice = _context8.sent;

                if (!(detectionString === getValues(slice, globals_js_1.fieldTypes.ASCII, detectionString.length, offset))) {
                  _context8.next = 19;
                  break;
                }

                valuesString = getValues(slice, globals_js_1.fieldTypes.ASCII, heuristicAreaSize, offset);
                firstLine = valuesString.split('\n')[0];
                metadataSize = Number(firstLine.split('=')[1].split(' ')[0]) + firstLine.length;

                if (!(metadataSize > heuristicAreaSize)) {
                  _context8.next = 16;
                  break;
                }

                _context8.next = 15;
                return this.getSlice(offset, metadataSize);

              case 15:
                slice = _context8.sent;

              case 16:
                fullString = getValues(slice, globals_js_1.fieldTypes.ASCII, metadataSize, offset);
                this.ghostValues = {};
                fullString.split('\n').filter(function (line) {
                  return line.length > 0;
                }).map(function (line) {
                  return line.split('=');
                }).forEach(function (_ref2) {
                  var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                      key = _ref3[0],
                      value = _ref3[1];

                  _this4.ghostValues[key] = value;
                });

              case 19:
                return _context8.abrupt("return", this.ghostValues);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getGhostValues() {
        return _getGhostValues.apply(this, arguments);
      }

      return getGhostValues;
    }()
    /**
     * Parse a (Geo)TIFF file from the given source.
     *
     * @param {*} source The source of data to parse from.
     * @param {GeoTIFFOptions} [options] Additional options.
     * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
     *                               to be aborted
     */

  }, {
    key: "close",
    value:
    /**
     * Closes the underlying file buffer
     * N.B. After the GeoTIFF has been completely processed it needs
     * to be closed but only if it has been constructed from a file.
     */
    function close() {
      if (typeof this.source.close === 'function') {
        return this.source.close();
      }

      return false;
    }
  }], [{
    key: "fromSource",
    value: function () {
      var _fromSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(source, options, signal) {
        var headerData, dataView, BOM, littleEndian, magicNumber, bigTiff, offsetByteSize, firstIFDOffset;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return source.fetch([{
                  offset: 0,
                  length: 1024
                }], signal);

              case 2:
                headerData = _context9.sent[0];
                dataView = new dataview64_js_1.default(headerData);
                BOM = dataView.getUint16(0, 0);

                if (!(BOM === 0x4949)) {
                  _context9.next = 9;
                  break;
                }

                littleEndian = true;
                _context9.next = 14;
                break;

              case 9:
                if (!(BOM === 0x4D4D)) {
                  _context9.next = 13;
                  break;
                }

                littleEndian = false;
                _context9.next = 14;
                break;

              case 13:
                throw new TypeError('Invalid byte order value.');

              case 14:
                magicNumber = dataView.getUint16(2, littleEndian);

                if (!(magicNumber === 42)) {
                  _context9.next = 19;
                  break;
                }

                bigTiff = false;
                _context9.next = 27;
                break;

              case 19:
                if (!(magicNumber === 43)) {
                  _context9.next = 26;
                  break;
                }

                bigTiff = true;
                offsetByteSize = dataView.getUint16(4, littleEndian);

                if (!(offsetByteSize !== 8)) {
                  _context9.next = 24;
                  break;
                }

                throw new Error('Unsupported offset byte-size.');

              case 24:
                _context9.next = 27;
                break;

              case 26:
                throw new TypeError('Invalid magic number.');

              case 27:
                firstIFDOffset = bigTiff ? dataView.getUint64(8, littleEndian) : dataView.getUint32(4, littleEndian);
                return _context9.abrupt("return", new GeoTIFF(source, littleEndian, bigTiff, firstIFDOffset, options));

              case 29:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function fromSource(_x5, _x6, _x7) {
        return _fromSource.apply(this, arguments);
      }

      return fromSource;
    }()
  }]);
  return GeoTIFF;
}(GeoTIFFBase);

exports.GeoTIFF = GeoTIFF;
exports.default = GeoTIFF;
/**
 * Wrapper for GeoTIFF files that have external overviews.
 * @augments GeoTIFFBase
 */

var MultiGeoTIFF = /*#__PURE__*/function (_GeoTIFFBase2) {
  (0, _inherits2.default)(MultiGeoTIFF, _GeoTIFFBase2);

  var _super3 = _createSuper(MultiGeoTIFF);

  /**
   * Construct a new MultiGeoTIFF from a main and several overview files.
   * @param {GeoTIFF} mainFile The main GeoTIFF file.
   * @param {GeoTIFF[]} overviewFiles An array of overview files.
   */
  function MultiGeoTIFF(mainFile, overviewFiles) {
    var _this5;

    (0, _classCallCheck2.default)(this, MultiGeoTIFF);
    _this5 = _super3.call(this);
    _this5.mainFile = mainFile;
    _this5.overviewFiles = overviewFiles;
    _this5.imageFiles = [mainFile].concat(overviewFiles);
    _this5.fileDirectoriesPerFile = null;
    _this5.fileDirectoriesPerFileParsing = null;
    _this5.imageCount = null;
    return _this5;
  }

  (0, _createClass2.default)(MultiGeoTIFF, [{
    key: "parseFileDirectoriesPerFile",
    value: function () {
      var _parseFileDirectoriesPerFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
        var requests;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                requests = [this.mainFile.parseFileDirectoryAt(this.mainFile.firstIFDOffset)].concat(this.overviewFiles.map(function (file) {
                  return file.parseFileDirectoryAt(file.firstIFDOffset);
                }));
                _context10.next = 3;
                return Promise.all(requests);

              case 3:
                this.fileDirectoriesPerFile = _context10.sent;
                return _context10.abrupt("return", this.fileDirectoriesPerFile);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function parseFileDirectoriesPerFile() {
        return _parseFileDirectoriesPerFile.apply(this, arguments);
      }

      return parseFileDirectoriesPerFile;
    }()
    /**
     * Get the n-th internal subfile of an image. By default, the first is returned.
     *
     * @param {number} [index=0] the index of the image to return.
     * @returns {Promise<GeoTIFFImage>} the image at the given index
     */

  }, {
    key: "getImage",
    value: function () {
      var _getImage2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
        var index,
            visited,
            relativeIndex,
            i,
            imageFile,
            ii,
            ifd,
            _args11 = arguments;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                index = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : 0;
                _context11.next = 3;
                return this.getImageCount();

              case 3:
                _context11.next = 5;
                return this.parseFileDirectoriesPerFile();

              case 5:
                visited = 0;
                relativeIndex = 0;
                i = 0;

              case 8:
                if (!(i < this.imageFiles.length)) {
                  _context11.next = 26;
                  break;
                }

                imageFile = this.imageFiles[i];
                ii = 0;

              case 11:
                if (!(ii < this.imageCounts[i])) {
                  _context11.next = 22;
                  break;
                }

                if (!(index === visited)) {
                  _context11.next = 17;
                  break;
                }

                _context11.next = 15;
                return imageFile.requestIFD(relativeIndex);

              case 15:
                ifd = _context11.sent;
                return _context11.abrupt("return", new geotiffimage_js_1.default(ifd.fileDirectory, ifd.geoKeyDirectory, imageFile.dataView, imageFile.littleEndian, imageFile.cache, imageFile.source));

              case 17:
                visited++;
                relativeIndex++;

              case 19:
                ii++;
                _context11.next = 11;
                break;

              case 22:
                relativeIndex = 0;

              case 23:
                i++;
                _context11.next = 8;
                break;

              case 26:
                throw new RangeError('Invalid image index');

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getImage() {
        return _getImage2.apply(this, arguments);
      }

      return getImage;
    }()
    /**
     * Returns the count of the internal subfiles.
     *
     * @returns {Promise<number>} the number of internal subfile images
     */

  }, {
    key: "getImageCount",
    value: function () {
      var _getImageCount2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
        var requests;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(this.imageCount !== null)) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return", this.imageCount);

              case 2:
                requests = [this.mainFile.getImageCount()].concat(this.overviewFiles.map(function (file) {
                  return file.getImageCount();
                }));
                _context12.next = 5;
                return Promise.all(requests);

              case 5:
                this.imageCounts = _context12.sent;
                this.imageCount = this.imageCounts.reduce(function (count, ifds) {
                  return count + ifds;
                }, 0);
                return _context12.abrupt("return", this.imageCount);

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getImageCount() {
        return _getImageCount2.apply(this, arguments);
      }

      return getImageCount;
    }()
  }]);
  return MultiGeoTIFF;
}(GeoTIFFBase);

exports.MultiGeoTIFF = MultiGeoTIFF;
/**
 * Creates a new GeoTIFF from a remote URL.
 * @param {string} url The URL to access the image from
 * @param {object} [options] Additional options to pass to the source.
 *                           See {@link makeRemoteSource} for details.
 * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                               to be aborted
 * @returns {Promise<GeoTIFF>} The resulting GeoTIFF file.
 */

function fromUrl(_x8) {
  return _fromUrl.apply(this, arguments);
}

function _fromUrl() {
  _fromUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(url) {
    var options,
        signal,
        _args13 = arguments;
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            options = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : {};
            signal = _args13.length > 2 ? _args13[2] : undefined;
            return _context13.abrupt("return", GeoTIFF.fromSource((0, remote_js_1.makeRemoteSource)(url, options), signal));

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _fromUrl.apply(this, arguments);
}

exports.fromUrl = fromUrl;
/**
 * Construct a new GeoTIFF from an
 * [ArrayBuffer]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer}.
 * @param {ArrayBuffer} arrayBuffer The data to read the file from.
 * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                               to be aborted
 * @returns {Promise<GeoTIFF>} The resulting GeoTIFF file.
 */

function fromArrayBuffer(_x9, _x10) {
  return _fromArrayBuffer.apply(this, arguments);
}

function _fromArrayBuffer() {
  _fromArrayBuffer = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(arrayBuffer, signal) {
    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", GeoTIFF.fromSource((0, arraybuffer_js_1.makeBufferSource)(arrayBuffer), signal));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _fromArrayBuffer.apply(this, arguments);
}

exports.fromArrayBuffer = fromArrayBuffer;
/**
 * Construct a GeoTIFF from a local file path. This uses the node
 * [filesystem API]{@link https://nodejs.org/api/fs.html} and is
 * not available on browsers.
 *
 * N.B. After the GeoTIFF has been completely processed it needs
 * to be closed but only if it has been constructed from a file.
 * @param {string} path The file path to read from.
 * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                               to be aborted
 * @returns {Promise<GeoTIFF>} The resulting GeoTIFF file.
 */

function fromFile(_x11, _x12) {
  return _fromFile.apply(this, arguments);
}

function _fromFile() {
  _fromFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(path, signal) {
    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", GeoTIFF.fromSource((0, file_js_1.makeFileSource)(path), signal));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _fromFile.apply(this, arguments);
}

exports.fromFile = fromFile;
/**
 * Construct a GeoTIFF from an HTML
 * [Blob]{@link https://developer.mozilla.org/en-US/docs/Web/API/Blob} or
 * [File]{@link https://developer.mozilla.org/en-US/docs/Web/API/File}
 * object.
 * @param {Blob|File} blob The Blob or File object to read from.
 * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                               to be aborted
 * @returns {Promise<GeoTIFF>} The resulting GeoTIFF file.
 */

function fromBlob(_x13, _x14) {
  return _fromBlob.apply(this, arguments);
}

function _fromBlob() {
  _fromBlob = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(blob, signal) {
    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", GeoTIFF.fromSource((0, filereader_js_1.makeFileReaderSource)(blob), signal));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _fromBlob.apply(this, arguments);
}

exports.fromBlob = fromBlob;
/**
 * Construct a MultiGeoTIFF from the given URLs.
 * @param {string} mainUrl The URL for the main file.
 * @param {string[]} overviewUrls An array of URLs for the overview images.
 * @param {Object} [options] Additional options to pass to the source.
 *                           See [makeRemoteSource]{@link module:source.makeRemoteSource}
 *                           for details.
 * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
 *                               to be aborted
 * @returns {Promise<MultiGeoTIFF>} The resulting MultiGeoTIFF file.
 */

function fromUrls(_x15) {
  return _fromUrls.apply(this, arguments);
}

function _fromUrls() {
  _fromUrls = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(mainUrl) {
    var overviewUrls,
        options,
        signal,
        mainFile,
        overviewFiles,
        _args17 = arguments;
    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            overviewUrls = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : [];
            options = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : {};
            signal = _args17.length > 3 ? _args17[3] : undefined;
            _context17.next = 5;
            return GeoTIFF.fromSource((0, remote_js_1.makeRemoteSource)(mainUrl, options), signal);

          case 5:
            mainFile = _context17.sent;
            _context17.next = 8;
            return Promise.all(overviewUrls.map(function (url) {
              return GeoTIFF.fromSource((0, remote_js_1.makeRemoteSource)(url, options));
            }));

          case 8:
            overviewFiles = _context17.sent;
            return _context17.abrupt("return", new MultiGeoTIFF(mainFile, overviewFiles));

          case 10:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _fromUrls.apply(this, arguments);
}

exports.fromUrls = fromUrls;
/**
 * Main creating function for GeoTIFF files.
 * @param {(Array)} array of pixel values
 * @returns {metadata} metadata
 */

function writeArrayBuffer(values, metadata) {
  return (0, geotiffwriter_js_1.writeGeotiff)(values, metadata);
}

exports.writeArrayBuffer = writeArrayBuffer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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